import React from "react";

interface PhoneFrameProps {
  children: React.ReactNode;
  className?: string;
}

export const PhoneFrame: React.FC<PhoneFrameProps> = ({ children, className = "" }) => (
  <div className={`relative ${className}`}>
    {/* Outer bezel */}
    <div className="rounded-[2.5rem] border-[3px] border-foreground/10 bg-background shadow-warm-lg overflow-hidden">
      {/* Status bar */}
      <div className="flex items-center justify-between px-6 py-1.5 bg-background">
        <span className="text-[10px] font-semibold text-muted-foreground/50">9:41</span>
        <div className="w-20 h-5 bg-foreground/10 rounded-full" />
        <div className="flex items-center gap-1">
          <div className="w-3.5 h-2 rounded-sm border border-muted-foreground/30" />
        </div>
      </div>
      {/* Content */}
      {children}
      {/* Home indicator */}
      <div className="flex justify-center py-2 bg-background">
        <div className="w-28 h-1 rounded-full bg-foreground/10" />
      </div>
    </div>
  </div>
);
